import React from "react";


const ReleaseManagement = ()=>{
    const SSOURL = process.env.REACT_APP_SSOURL;
    return(
        <iframe src={`${SSOURL}/apps/release-management`} style={{ width: "100%", height: "85vh",border:"none" }} title="Dynamic Content"></iframe>
    )
}

export default ReleaseManagement;
